import { render, staticRenderFns } from "./sub_notice2.vue?vue&type=template&id=33fe965f&scoped=true&"
import script from "./sub_notice2.vue?vue&type=script&lang=js&"
export * from "./sub_notice2.vue?vue&type=script&lang=js&"
import style0 from "./sub_notice2.vue?vue&type=style&index=0&id=33fe965f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fe965f",
  null
  
)

export default component.exports